<template>
  <div class="addInspectionLineSetting">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back()">{{$t('lang.btn_returnPatrolRouteSettings')}}</el-button>
      </div>
      <el-form :label-width="require('@/config/enum').c_ws5" :label-suffix="require('@/config/enum').c_colon" ref="form" :inline="true" class="wid100">
        <el-form-item :label="$t('lang.lab_planName')" prop="name" class="width_left60">
          <span>{{name}}</span>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_pointType')" prop="picture" class="width_left">
          <span v-for="item in tableData" :key="item.id" class="pointTypeImg">
            <img :src="require('../../../assets/imgs' + item.url.toString())"/>{{item.name}}
          </span>
        </el-form-item>
      </el-form>
      <div class="positionPoint" :style="'width:' + left + 'px' + ';' + 'height:' + top + 'px' + ';'" @dblclick="add($event)">
        <div v-for='(item, index) in sign' v-bind:key='index.pointId'>
          <el-popover
            placement="top"
            trigger="hover"
            :title="pointName">
            <p>{{item.msg}}</p>
            <div :style="'left:' + item.left + ';' + 'top:' + item.top + ';'" class="pointImg" slot="reference">
              <img :src="require('../../../assets/imgs' + item.ptypecss.toString())"/>
            </div>
          </el-popover>
          <div :style="'left:' + item.left + ';' + 'top:' + item.top " class="pointSpan">
            <span>{{item.msg}}</span>
          </div>
        </div>
    </div>
    <img :src="getImgUrl" class="getImg">
    <el-form ref="form" class="buttomForm" :label-width="require('@/config/enum').c_ws5" :label-suffix="require('@/config/enum').c_colon" :rules="rules" :model="form">
      <el-form-item :label="$t('lang.lab_lineName')" prop="patrolPointLinePerson">
        <el-input v-model="form.patrolPointLinePerson" :placeholder="$t('lang.lab_inputLabel')" class="pointLine"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.lab_goawayaway')" prop="patrolPointLineSeq">
        <el-select class="select" v-model="form.patrolPointLineSeq">
          <el-option key :label="$t('lang.lab_please_Select') + $t('lang.lab_goawayaway')" value=''></el-option>
          <el-option
            v-for="item in patrolPointLineSeqList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('lang.lab_goawayGroup')" prop="patrolPersonnelAllocation">
        <el-select class="select" v-model="form.patrolPersonnelAllocation" filterable v-loadmore="loadMore">
          <el-option key :label="$t('lang.lab_please_Select') + $t('lang.lab_goawayGroup')" value=''></el-option>
          <el-option
            v-for="item in patrolPersonnelAllocationList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-button class="btn-first martop" @click="rest('form')">{{$t('lang.btn_rest')}}</el-button>
    <el-button type="primary" class="detailbtn" :disabled="isDisabled" @click="savePatrolType('form')">{{$t('lang.btn_save')}}</el-button>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:addInspectionLineSetting
 *@Description:巡检路线/添加
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-20
 */
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      saveData: '', // 存储json字符串
      getImgUrl: '', // 获取的图片URL
      pointName: this.$i18n.t('lang.lab_pointName'), // 点位名称
      x: 0, // 点击图片后点击位置位于图片的left百分比
      y: 0, // 点击图片后点击位置位于图片的top百分比
      left: 0, // 获取图片的宽度
      top: 0, // 获取图片的高
      id: '', // 编辑按钮传的ID
      changePage: 12, // 下拉框的接口
      isDisabled: false, // 编辑时控制保存按钮是否可点击
      name: '',
      form: {
        patrolPointLineSeq: '', // 巡更分组
        patrolPersonnelAllocation: '', // 点位顺序名称
        patrolPointLinePerson: '' // 线路名称下拉
      },
      rules: {
        patrolPointLinePerson: [
          { required: true, message: '请输入线路名称', trigger: 'blur' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        patrolPointLineSeq: [
          { required: true, message: '请选择巡更点位顺序', trigger: 'change' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        patrolPersonnelAllocation: [
          { required: true, message: '请选择巡更分组', trigger: 'change' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
      },
      PatrolTypeId: '',
      PlanarGraphId: '',
      sign: [], // 获取原来图片添加点位的参数数组
      signList: [], // 存储点位在图片上信息的数组
      trueUrl: '', // 本页转换后的图片
      tableData: [], // 存放巡检类型的数组
      patrolPointLinePerson: '', // 线路名称
      patrolPointLineSeq: '', // 巡更点位顺序名称
      patrolPointLineSeqList: [], // 巡更点位顺序名称下拉数组
      patrolPersonnelAllocation: '', // 巡更分组ID
      patrolPersonnelAllocationList: [], // 巡更分组下拉列表数组
    }
  },
  created() {
    this.id = this.$route.query.id
    console.log(this.id)
    this.PlanarGraphId = this.$route.query.addId
    this.PatrolTypeId = this.$route.query.addTypeId
    this.showPoint() // 获取点位按钮
    this.showImg() // 获取最大的图片
    this.getPointList() // 获取图片中点位信息
    this.getPatrolPointSequence() // 获取巡更点位顺序列表
    this.getPatrolPersonnelAllocationList() // 获取巡更分组列表
    if (this.id && this.id != '') {
      this.editShow() // 编辑根据id获取内容
    }
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    form: {
      handler(newVal, oldVal) {
       let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    loadMore() {
      this.getPatrolPersonnelAllocationList()
    },
    // 获取所有点位按钮样式
    showPoint() {
      let loading = this.$loading()
      this.$get(`/patrolType?GardenId=${this.gardenId}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 根据ID获取内容
    editShow() {
      let loading = this.$loading()
      this.$get(`/patrolPointLineById/${this.id}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form.patrolPointLineSeq = res.patrolPointLine.patrolPointSequenceId
            this.form.patrolPersonnelAllocation = res.patrolPointLine.patrolPersonnelAllocationId
            this.form.patrolPointLinePerson = res.patrolPointLine.name
            this.saveData = JSON.stringify(this.form)
            console.log(this.saveData)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取本平面图的信息
    showImg() {
      let loading = this.$loading()
      this.$get(`/planarGraphById/${this.PlanarGraphId}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.name = res.name
            this.getImgUrl = res.urls[0]
            // 存储图片的宽高
            var img = new Image()
            img.src = this.getImgUrl
            this.left = img.width
            this.top = img.height
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取图片上的点位信息
    getPointList() {
      let loading = this.$loading()
      this.$get(`/patrolPointList?GardenId=${this.gardenId}&PlanarGraphId=${this.PlanarGraphId}&PatrolTypeId=${this.PatrolTypeId}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.sign = res.pointJsonArray
            this.signList = res.pointJsonArray
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取巡更点位信息
    getPatrolPointSequence() {
      let loading = this.$loading()
      this.$get(`/patrolPointSequence?GardenId=${this.gardenId}&PlanarGraphId=${this.PlanarGraphId}&PatrolTypeId=${this.PatrolTypeId}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.patrolPointLineSeqList = res.list
            console.log(this.patrolPointLineSeqList)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取巡更分组
    getPatrolPersonnelAllocationList() {
      let loading = this.$loading()
      this.$get(`/patrolPersonnelAllocation?GardenId=${this.gardenId}&pageSize=${this.changePage}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.patrolPersonnelAllocationList = res.list
            this.changePage = this.changePage + 12
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 保存巡更路线
    savePatrolType(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.id === '' || this.id === undefined) {
            let params = {
              GardenId: this.gardenId,
              PlanarGraphId: this.PlanarGraphId,
              PatrolTypeId: this.PatrolTypeId,
              PatrolPointSequenceId: this.form.patrolPointLineSeq,
              PatrolPersonnelAllocationId: this.form.patrolPersonnelAllocation,
              Name: this.form.patrolPointLinePerson
            }
            let loading = this.$loading()
            // 为了匹配Swagger标签，content-type传递application/json格式
            this.$postJson(`/patrolPointLine`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.$router.push({ name: 'InspectionLineSetting', query: { id: this.PlanarGraphId, typeId: this.PatrolTypeId } })
                }
                setTimeout(() => {
                  loading.close()
                }, 200)
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            // 进入编辑
            let params = {
              GardenId: this.gardenId,
              PlanarGraphId: this.PlanarGraphId,
              PatrolTypeId: this.PatrolTypeId,
              PatrolPointSequenceId: this.form.patrolPointLineSeq,
              PatrolPersonnelAllocationId: this.form.patrolPersonnelAllocation,
              Name: this.form.patrolPointLinePerson
            }
            let loading = this.$loading()
            this.$patch(`/patrolPointLine/${this.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.$router.push({ name: 'InspectionLineSetting', query: { id: this.PlanarGraphId, typeId: this.PatrolTypeId } })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        } else {
          return false
        }
      })
    },
    back() {
      this.$router.push({ name: 'InspectionLineSetting', query: { id: this.PlanarGraphId, typeId: this.PatrolTypeId } })
    },
    rest(form) {
      this.$refs[ form ].resetFields()
      this.form.patrolPointLineSeq = ''
      this.form.patrolPersonnelAllocation = ''
      this.form.patrolPointLinePerson = ''
    }
  }
}
</script>

<style lang="scss">
  .addInspectionLineSetting {
    .martop {
      margin-top: 20px;
      margin-left: 20px;
    }
    overflow: hidden;
    position: relative;
    .buttomForm {
      margin-top: 30px;
      .el-form-item {
        height: 50px;
      }
    }
    .el-form-item__content {
      .pointTypeImg {
        display: inline-block;
        min-width: 140px;
        img {
          width: 25px;
        }
      }
    }
    .width_left60 {
      min-width: 75%;
    }
    .positionPoint {
      margin-left: 130px;
      position: absolute;
    }
    .blueSpan {
      color:#409eff;
    }
    .width_left {
      max-width: 80%;
      .el-form-item__content {
        max-width: 80%;
      }
    }
    .getImg {
      margin-left: 130px;
    }
    .pointImg {
      position: absolute;
      margin-left: -25px;
      margin-top: -40px;
      width: 40px;
      height: 50px;
      display: block;
    }
    .pointSpan {
      position: absolute;
      color: #F00;
      width: 150px;
      height: 50px;
      span {
        font-weight: 900;
        font-size: 150%;
        color: #F00;
      }
    }
    .el-popover {
      min-width: 200px !important;
      min-height: 150px !important;
      .topButtom {
        margin: 0;
        padding: 0;
        text-align: right;
        position: absolute;
        top: 5px;
        right: 5px;
        float: right;
        .el-button {
          margin: 1px;
          padding: 5px;
        }
      }
    }
    .pointLine {
      .el-input__inner {
        width: 30%;
      }
    }
  }
</style>